/* eslint-disable */
import React, { Component } from "react";
import {
  List,
  Button,
  TransitionablePortal,
  Header,
  Icon,
  Modal,
  Image,
  Popup,
  Segment,
  Divider,
} from "semantic-ui-react";
import moment from "moment"
import * as hinchLogo from "../../../assets/logosquare.png";

class GeneralInfoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
        showModal: false,
        imagePath: undefined,
        generalInfo: []
    };
  }
  componentWillMount() {
    if (this.props.reportDetails.report_type != "custom") {

      this.props.reportDetails.title ? this.addToGeneralInfo({ name: "Title Image", images: [{ ...this.props.reportDetails.title.images, notes: [{ header: "", info: "Title Image" }] }] }) : null
      this.props.reportDetails.soc ? this.addToGeneralInfo({ name: "Schedule Of Condition", images: [{ ...this.props.reportDetails.soc.images, notes: [{ header: "", info: "Schedule of Condition" }] }] }) : null
      this.props.reportDetails.co_keys_image && this.props.reportDetails.is_co_report === true ? this.addToGeneralInfo({ name: "Keys", images: [{ ...this.props.reportDetails.co_keys_image, notes: this.props.reportDetails.keys.map(key => { return { header: "", info: key.co_no_of_keys + " X " + key.co_description } })}] })  : null
      this.props.reportDetails.ci_keys_image && this.props.reportDetails.is_co_report === false ? this.addToGeneralInfo({ name: "Keys", images: [{ ...this.props.reportDetails.ci_keys_image, notes: this.props.reportDetails.keys.map(key => { return { header: "", info: key.ci_no_of_keys + " X " + key.ci_description } }) }] }) : null
      this.props.reportDetails.alarms.length > 0 && this.props.reportDetails.is_co_report === true ? this.addToGeneralInfo({ name: "Alarms", images: this.props.reportDetails.alarms.map(alarm => { return { ...alarm.co_image, notes: [{ header: "Location", info: alarm.co_location }, { header: "Condition at Check In", info: alarm.ci_description }, { header: "Condition at Check Out", info: alarm.co_description }] } }) }) : null
      this.props.reportDetails.alarms.length > 0 && this.props.reportDetails.is_co_report === false ? this.addToGeneralInfo({ name: "Alarms", images: this.props.reportDetails.alarms.map(alarm => { return { ...alarm.ci_image, notes: [{ header: "Location", info: alarm.ci_location }, { header: "Condition", info: alarm.ci_description }] } }) }) : null
      this.props.reportDetails.meters ? this.addToGeneralInfo({
        name: "Meters", flag:"generaldetailsmeters", images: this.parseMeters(this.props.reportDetails.meters)
      }) : null
      this.props.reportDetails.disclaimers ? this.parseDisclaimers(this.props.reportDetails.disclaimers) : null
      this.props.reportDetails.receipts.length > 0 ? this.addToGeneralInfo({ name: "Cleaning Receipts", images: this.props.reportDetails.receipts.map(receipt => { return { ...receipt.images, notes: [{ header: "Cleaning Receipt", info: receipt.description }] } }) }) : null
      this.props.reportDetails.inspection.additional_images.length > 0 ? this.addToGeneralInfo({ name: "Additional Images", images: this.props.reportDetails.inspection.additional_images.sort((a,b)=>{return (a.file_name || "1").localeCompare (b.file_name || "1")}).map(image => { return { ...image, notes: [{ header: "Additional Images", info: null }] } }) }) : null
      this.props.reportDetails.inspection.customer_service_queries.length > 0 ? this.props.reportDetails.inspection.customer_service_queries.map(
        query => {
          return (query.customer_service_query_images.length > 0 && query.visible_in_report) ? this.addToGeneralInfo(
            { name: "Customer Service Comment - " + moment(query.created_at, "YYYY-MM-DD HH:mm Z").format("DD-MM-YYYY") , images: query.customer_service_query_images.map(image => { return { ...image,notes: [{ header: "Querier Name", info: query.querier_name },{ header: "Querier Relation", info: query.querier_relation },{ header: "Query Comment", info: query.query_comment }] } }) }) : null
        }) : null
      // this.props.reportDetails.rooms.length > 0 ? this.addRoomPhotosToIndex(this.props.reportDetails.rooms) : null;
    } 
    else
    {
      this.props.reportDetails.additional_images.length > 0 ? this.addToGeneralInfo({ name: "Additional Images", images: this.props.reportDetails.additional_images.sort((a,b)=>{return (a.file_name || "1").localeCompare (b.file_name || "1")}).map(image => { return { ...image, notes: [{ header: "Additional Images", info: null }] } }) }) : null
      }
    }

  parseDisclaimers = (disclaimers) => {
    let sectionDict = {notes: "Additional Notes - ", disclaimer: "Disclaimer - ", customer_service: "Customer Service Note - "}
    disclaimers.map(disclaimer => {
      let sectionTitle = sectionDict[disclaimer.section_type] + disclaimer.title
      let images = []
      disclaimer.images.length > 0 ? disclaimer.images.map(image =>{images.push({...image, notes:[{header:disclaimer.title, info:disclaimer.description}]})}) : images.push({image_path:hinchLogo, id:disclaimer.client_id, notes:[{header:disclaimer.title, info:disclaimer.description}]})
      this.addToGeneralInfo({name:sectionTitle, images:images})
    })
  }

  parseMeters = (meters) => {
    let readings = []
    meters.map((meter) => {
      meter.readings.map(reading => {
        if (this.props.reportDetails.is_co_report) {
          return reading.co_image ? readings.push(
            { ...reading.co_image, notes: [{ header: "Meter Type", info: meter.name }, { header: "Location", info: meter.ci_location },{header: "Check In Reading", info:reading.ci_value},{header: "Check Out Reading", info:reading.co_value} ] }) : null
        }
        else {
          return reading.ci_image? readings.push(
            { ...reading.ci_image, notes: [{ header: "Meter Type", info: meter.name }, { header: "Location", info: meter.ci_location }, {header: "Check In Reading", info:reading.ci_value}] }) : null
        }
      })
    })
    return readings
  }
    addToGeneralInfo = (section) => {
        var newState = { ...this.state }
        newState.generalInfo.push(section)
        section.images.map(image => { this.props.addToImagesList(image) })
        this.setState(...newState)
                }
    


                renderPCM = () =>{return <a href="https://www.pleaseconnectme.co.uk/hinch-property-management/">
                <Image src={"https://www.hinchpm.com/wp-content/uploads/2026/06/Hinch-banne-new-pleaseconnectmer-scaled.png"}></Image></a>}
    render() {
 
    return (
      <React.Fragment>
        <div className="nested-segment">
                <Header id="generaldetails" className="nested-segment" as="h3" attached="top"><Icon color="blue" name="list" />
                    <Header.Content>General Information <a href="#top" > <Button compact basic >Back to Top</Button></a></Header.Content> 
          </Header>
          <Segment attached className="nested-segment">
            {this.state.generalInfo ? this.state.generalInfo.map((section) => {
               return <React.Fragment key={section.name}>
                  <div className="nested-segment">
                    <Segment secondary attached="top">
                      <Header id={section.flag}  as="h3"><Icon color="grey" name="photo" /> {section.name}</Header>
                    </Segment>
                    <Segment attached>
                      <Image.Group size="small">
                                  {section.images ? section.images.map((image) => {
                                          return (image.image_path?<Popup
                                              key={image.id}
                                              trigger={
                                                  <Image
                                                      style={{ cursor: "pointer" }}
                                                      className="grow"
                                                      onClick={() => {this.props.setCurrentImage(image)
                                                      }}
                                                      rounded
                                                      src={image.image_path}
                                                      target="_blank"
                                                  />}
                                              content={<List divided>
                                                  {image.notes? image.notes.map((note) => {
                                                      return <List.Item key={note.info}>
                                                          <List.Content>
                                                              <List.Header
                                                                  style={{ color: "#4183c4" }}>
                                                                  {note.header}
                                                              </List.Header>
                                                              <List.Description>
                                                                  {note.info}
                                                              </List.Description>
                                                          </List.Content>
                                                      </List.Item>
                                                  }):null}</List>}
                                          />:null
                                          )
                                  }) : null}
                      </Image.Group>

                      {section.name == "Meters" && this.props.reportDetails.please_connect_me == true && this.renderPCM()}
                    </Segment>
                  </div> <Divider section />
                </React.Fragment>
            }):null}
          </Segment>
        </div>
        <Divider section />
      </React.Fragment>
    );
  }
}

export default GeneralInfoContainer;



// WEBPACK FOOTER //
// ./src/views/report/report_viewer/general_info_container.js